import Enum from '../enum'

/**
 * スケジュール 雨天時対応
 *
 * [1:雨天決行 2:雨天延期 3:雨天中止]
 */
class RainType extends Enum {
    static CARRY_OUT = 1; // 雨天決行
    static POSTPONE = 2; // 雨天延期
    static CANCEL = 3; // 雨天中止

    static values() {
        return {
            [this.CARRY_OUT]: '雨天決行',
            [this.POSTPONE]: '雨天延期',
            [this.CANCEL]: '雨天中止',
        }
    }
}

export default RainType;